module.exports = __webpack_public_path__ + "static/media/2_r_kirpichi_55.68_89.63.001ad280.png";